module.exports = __webpack_public_path__ + "img/multiplier_normal_2.eb6d0b9c.png";